module.exports = __webpack_public_path__ + "img/service-tongyizhifu2.175f41e7.svg";